import RightPopupComponent from "components/RightPopup";

import ItemClient from "components/ItemClient";

import './index.less';
import './themes/default.less';

export default class ShiftPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.days = {
            0: "monday",
            1: "tuesday",
            2: "wednesday",
            3: "thursday",
            4: "friday",
            5: "saturday",
            6: "sunday"
        };

        this.defaultState = {
            ...this.state,
            startTime: "",
            endTime: "",
            visits: null,
            busyTimeStart: null,
            busyTimeEnd: null,
            currentCabinet: null,
            repeatType: 'DAILY',
            editDate: false,
            editEndDate: false,
            regular: false,
            onlyTheShift: false
        };

        this.state = {
            ...this.defaultState
        };

    }

    get popupName() {
        return "addAppPopup";
    }

    show(info, hideCb) {
        this.state.info = { ...this.state.info, ...info };
        const { edit, beginDate, endDate, regular, onlyTheShift } = info;
        if (edit) {
            this.state.info.start = beginDate.substring(11, 16);
            this.state.info.end = endDate.substring(11, 16);
        }
        const startTime = this.state.info.start.slice(0, 5);
        const endTime = this.state.info.end.slice(0, 5);
        const currentCabinet = this.state.info.cabinetId;
        const visits = null;

        this.dialogTitle = this.state.info.id ? "app.changeApp" : "schedule.newShift";

        this.hidCb = hideCb;

        this.setState({ startTime, endTime, visits, currentCabinet, regular, onlyTheShift });
        super.show();
    }

    async onShow() {
        const { parent } = this.state.info;
        await this.checkVisits();
        if (parent?.id) {
            const infoShedResp = await this._request.doctorsSchedule.getScheduleByParentId(parent?.id);
            if (infoShedResp?.data[0]) {
                const repeatType = infoShedResp?.data[0].repeatType;
                const editDate = infoShedResp?.data[0].beginDate;
                const editEndDate = infoShedResp?.data[0].endDate;
                this.setState({ repeatType, editDate, editEndDate });
            } else {
                this.state.repeatType = 'DAILY';
            }
        }
    }

    async checkVisits() {
        const { domainId, doctorId, beginDate, endDate } = this.state.info;

        this._helper.showLoading();
        const visitsResp = await this._request.visits.checkVisits(domainId, doctorId, beginDate, endDate, true);
        this._helper.hideLoading();
        const visits = visitsResp?.data.sort((a, b) => new Date(a.beginDate) - new Date(b.beginDate)) || null;

        let busyTimeStart = null;
        let busyTimeEnd = null;
        if (visits?.length > 0) {
            busyTimeStart = visits[0].beginDate;
            busyTimeEnd = visits[visits.length - 1].endDate;
        }

        this.setState({ visits, busyTimeStart, busyTimeEnd });
    }

    onHide() {
        this.setState({
            needClear: false,
            needConsult: false,
            withoutPatient: false,
            info: { ...this.blankInfo }
        });
    }

    async save() {
        const { info, currentCabinet, repeatType, editDate, editEndDate, onlyTheShift } = this.state;
        const { domainId, doctorId, parent, cabinetId } = info;
        const date = (editDate && !onlyTheShift) ? new Date(editDate) : info.date;
        let date2 = date;
        if (!parent?.id && repeatType === "WEEKLY") {
            date2 = this._helper.date.addMonth(date, 1);
        } else if (parent?.id && repeatType === "WEEKLY" && !onlyTheShift) {
            date2 = new Date(editEndDate);
        }

        if (!this[`startTime`].value || !this[`endTime`].value)
            return this.showError("schedule.noTime", "schedule.errorSave");

        const beginDate = this._helper.date.setTime(date, this[`startTime`].value);
        let endDate = this._helper.date.setTime(date2, this[`endTime`].value);

        const diff = Number(endDate) - Number(beginDate) >= 300000;
        if (!diff)
            return this.showError("schedule.errorPeriod5m", "schedule.errorPeriod");

        const dayOfWeekList = this._config.dayOfWeek;

        let shifts = null;
        let infoShed = null;

        let d1 = new Date(info.date);
        let d2 = (repeatType === "WEEKLY" && !onlyTheShift) ? this._helper.date.addMonth(info.date, 1) : new Date(info.date);
        let dayOfWeek = "";
        this._helper.showLoading();
        if (parent?.id) {
            const resp = await this._request.doctorsSchedule.getScheduleByParentId(parent?.id);
            infoShed = resp?.data ? resp?.data[0] : null;
            dayOfWeek = infoShed.dayOfWeek;
            if (!infoShed) {
                this._helper.hideLoading();
                return this.showError("Error save visit", "Ошибка");
            }

            const infoShedResp = await this._request.doctorsSchedule.getShiftsByParentId(parent?.id);

            shifts = (infoShedResp?.data || []);

            d1 = onlyTheShift ? new Date(beginDate) : new Date(shifts[0].beginDate);
            d2 = onlyTheShift ? new Date(endDate) : new Date(shifts[shifts.length - 1].endDate);
        }

        const infoCheck = {
            doctorId,
            d1,
            d2,
            domainId,
            shifts,
            repeatType,
            hourOn: this[`startTime`].value,
            hourOff: this[`endTime`].value,
            onlyTheShift,
            cabinetId: currentCabinet,
            parentId: parent?.id,
            info
        };

        const docBusyOtherClinic = await this._request.doctorsSchedule.checkDocBusyOtherClinic(infoCheck);
        if (docBusyOtherClinic) {
            this._helper.hideLoading();
            return this.showError(`Доктор записан в клинике ${this._helper.getClinicNameById(docBusyOtherClinic)}`, "schedule.timeCrossing");
        }

        const busyCabinet = await this._request.doctorsSchedule.checkBusyCabinet(infoCheck);
        if (busyCabinet) {
            this._helper.hideLoading();
            let text = "";
            busyCabinet.forEach(it => {
                const dd1 = this._helper.date.toStr(this._helper.date.toLocal(it.beginDate), "DD.MM.YYYY HH:mm");
                const dd2 = this._helper.date.toStr(this._helper.date.toLocal(it.endDate), "HH:mm");
                text += `${dd1} - ${dd2}   `;
            });

            return this.showError(`Время ${text}`, "Кабинет занят");
        }

        if (parent?.id) {
            const crashVisits = await this._request.visits.checkCrashVisits(infoCheck);
            if (crashVisits) {
                this._helper.hideLoading();
                return this.showError("В смене есть визиты", "schedule.timeCrossing");
            }
        }

        if (cabinetId !== currentCabinet) {
            const existVisits = await this._request.visits.checkExistVisits(domainId, doctorId, d1, d2, repeatType);
            if (existVisits) {
                this._helper.hideLoading();
                return this.showError("В смене есть визиты, смена кабинета не возможна", "schedule.timeCrossing");
            }
        }

        this._helper.hideLoading();

        const toDateServ = this._helper.date.toDateServerStr(date);
        const toDateServ2 = this._helper.date.toDateServerStr(date2);

        if (!dayOfWeek)
            dayOfWeek = dayOfWeekList[this._helper.date.getNumberDayOfWeek(date)];
        const data = {
            domainId,
            doctorId,
            cabinetId: currentCabinet,
            beginDate: toDateServ,
            endDate: toDateServ2,
            beginTime: this._helper.date.toTimeUTCString(beginDate),
            endTime: this._helper.date.toTimeUTCString(endDate),
            repeatType,
            dayOfWeek
        };

        // ошибку исправить что бы при невыбранном докторе писало сообщение

        this.saveSend(data, onlyTheShift, infoShed, d1, d2);

    }

    async saveSend(info, onlyTheShift, infoShed, d1, d2) {
        this._helper.showLoading();
        const { parent } = this.state.info;

        let resp = null;

        if (parent?.id) {
            if (onlyTheShift && info.repeatType !== "DAILY") {
                const { beginDate, endDate } = infoShed;

                const begDate = this._helper.date.addDays(d2, +1);
                const begDateFormat = this._helper.date.toDateServerStr(begDate);
                const finDate = this._helper.date.addDays(d1, -1);
                const finDateFormat = this._helper.date.toDateServerStr(finDate);

                const beginDateEq = this._helper.date.equealDates(new Date(beginDate), d1);
                const endDateEq = this._helper.date.equealDates(new Date(endDate), d2);

                if (!beginDateEq && !endDateEq) {
                    await this._request.doctorsSchedule.update(parent?.id, { endDate: finDateFormat });
                    const infoData = { ...infoShed, beginDate: begDateFormat };
                    await this._request.doctorsSchedule.add(infoData);
                } else if (beginDateEq) {
                    await this._request.doctorsSchedule.update(parent?.id, { beginDate: begDateFormat });
                } else if (endDateEq) {
                    await this._request.doctorsSchedule.update(parent?.id, { endDate: finDateFormat });
                }

                resp = await this._request.doctorsSchedule.add({ ...info, repeatType: "DAILY" });

            } else {
                resp = await this._request.doctorsSchedule.update(parent?.id, info);
            }
        } else {
            resp = await this._request.doctorsSchedule.add(info);
        }

        this._helper.hideLoading();

        if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
        }
    }

    changeInfoState(key, value, cb) {
        const { info } = this.state;
        info[key] = value;

        this.setState({ info }, cb?.apply ? cb : null);
    }

    setValue(el, id) {
        if (el && id)
            el.value = id;
    }

    onBlurInput(source, time) {
        //this[`${src}Time${i}`].validateCb(this.checkValue);
    }

    renderHours() {
        const { startTime, endTime } = this.state;

        return (<div className="hours flex col gap4">
            <div className="gray text p2">
                Время
            </div>
            <div className="flex gap4 centerV">
                <div className="wrapInput">
                    {this.insertInput({
                        ref: el => this[`startTime`] = el,
                        itemStyle: "flex1",
                        value: startTime,
                        validator: this._helper.inputValidators.formatTime,
                        onChange: this.changeState.bind(this, "startTime"),
                        onBlur: this.onBlurInput.bind(this, "start"),
                        caption: ""
                    })}
                </div>
                <div className="wrapText">{'\u2014'}</div>
                <div className="wrapInput">
                    {this.insertInput({
                        ref: el => this[`endTime`] = el,
                        itemStyle: "flex1",
                        value: endTime,
                        validator: this._helper.inputValidators.formatTime,
                        onChange: this.changeState.bind(this, "endTime"),
                        onBlur: this.onBlurInput.bind(this, "end"),
                        caption: ""
                    })}
                </div>
            </div>
        </div>);
    }

    renderContent() {
        const { info, visits, currentCabinet, repeatType,
            editDate, editEndDate, onlyTheShift } = this.state;
        const { title, doctorId, assistantId, date, edit, domainId } = info;
        const numberDayOfWeek = this._helper.date.getNumberDayOfWeek(date);

        const dt = editDate ? editDate : date;
        const dte = editEndDate ? this._helper.date.toStr(editEndDate, "DD MMMM YYYY") :
            this._helper.date.toStr(this._helper.date.addMonth(dt, 1), "DD MMMM YYYY");

        const cabinets = this._helper.getCabinets(domainId);

        const textDay = this._helper.date.toStr(date, "DD MMMM YYYY");
        const textWeekly = `${this._helper.date.toStr(dt, "DD MMMM")} - ${dte}`;

        const textForWeek = {
            key: 0,
            name: this.tr(`scheduleDays.${this.days[numberDayOfWeek]}Every`) + ` ${textWeekly}`,
            value: "WEEKLY",
        };

        const textForDay = {
            key: 1,
            name: this.tr(`scheduleDays.${this.days[numberDayOfWeek]}`) + `, ${textDay}`,
            value: "DAILY",
        };

        const scheduleVariants = [];
        if (editDate) {
            if (!onlyTheShift)
                scheduleVariants.push(textForWeek);
            else
                scheduleVariants.push(textForDay);
        } else {
            scheduleVariants.push(textForDay);
            scheduleVariants.push(textForWeek);
        }

        return (
            <div className="shiftPopup flex col gap16">
                <div className="mainInfo text p1 flex gap16">
                    <div>{this.tr("schedule", "cabinet")}</div>
                    <div>{title}</div>
                </div>
                {this.insertRadioBlock({
                    value: repeatType,
                    title: "schedule.day",
                    items: scheduleVariants,
                    onChange: this.changeState.bind(this, "repeatType"),
                    disabled: edit
                })}
                {this.insertSelect({
                    value: currentCabinet,
                    label: this._helper.string.capitalize(this.tr("main.oneCab")),
                    labelKey: "title",
                    showLeftIcon: false,
                    items: cabinets,
                    onChange: this.changeState.bind(this, "currentCabinet")
                })}
                {this.renderHours()}
                <div className="flex1 flex col gap24">
                    {this.insertSelectDoctor({
                        value: doctorId,
                        label: "client.doctor",
                        onClick: edit ? null : this.changeInfoState.bind(this, "doctorId")
                    })}
                    {this.insertSelectDoctor({
                        value: assistantId,
                        type: "assistent",
                        label: "client.assistant",
                        hide: true,
                        searchPlaceHolder: "main.searchAssist",
                        onClick: this.changeInfoState.bind(this, "assistantId")
                    })}
                </div>
                {visits?.length > 0 && <div className="flex col gap16">
                    <div>{this.insertParagraf("Есть записи на это время")}</div>
                    <div>
                        {visits.map(it => (<div className="flex gap8 centerV">
                            <div className="text">
                                <div>{this._helper.date.toTimeUTCString(it.beginDate, true)}</div>
                                <div>{this._helper.date.toTimeUTCString(it.endDate, true)}</div>
                            </div>
                            {it.client ? <ItemClient
                                info={it.client}
                            /> : <div>Без пациента</div>}
                        </div>))}
                    </div>
                </div>}
            </div>
        );
    }
}
